module.exports = "/_next/static/images/health_tracker-2018b86f2450b25442f146d569d4329e.png";